import {getCurrentYear} from '../../utils/commons'
import BestProductsChoicesLogo from './logo'
import {bestProductsChoicesStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestproductschoices' as const,
  domainType: 'brg' as const,
  siteName: 'Best Products Choices',
  favicon: '/favicons/bestproductschoices.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-5P85TX17XZ',
    camelCaseUrl: 'BestProductsChoices.com',
    title: (category: string, count: string) =>
      `Best ${count} ${category} to Buy in ${getCurrentYear()} | BestProductsChoices.com – Smart Choices & Trusted Reviews`,
    description: (category?: string, count?: string) =>
      `Compare the best ${count} ${category} for ${getCurrentYear()} at BestProductsChoices.com. Honest reviews, side-by-side comparisons, and expert recommendations for smarter shopping decisions.`,
    styles: bestProductsChoicesStylesUS,
    logo: <BestProductsChoicesLogo className="size-12 shrink-0 tablet:size-8" locale="us" />,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
